import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercept 401s — try refresh, then redirect to login
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401 && !error.config._retry && !error.config.url?.includes('/auth/')) {
      error.config._retry = true;
      try {
        await axios.post(`${API_BASE}/auth/refresh`, {}, { withCredentials: true });
        return api(error.config);
      } catch {
        window.location.href = '/login';
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

// Analytics
export const getAnalyticsOverview = () => api.get('/analytics/overview');

// Conversations
export const getConversations = (status, limit = 50) => 
  api.get('/conversations', { params: { status, limit } });
export const getConversation = (id) => api.get(`/conversations/${id}`);
export const getConversationMessages = (id, limit = 100) => 
  api.get(`/conversations/${id}/messages`, { params: { limit } });
export const updateConversationStatus = (id, status) => 
  api.put(`/conversations/${id}/status`, null, { params: { status } });

// Knowledge Base Categories
export const getCategories = () => api.get('/knowledge/categories');
export const createCategory = (data) => api.post('/knowledge/categories', data);
export const updateCategory = (id, data) => api.put(`/knowledge/categories/${id}`, data);
export const deleteCategory = (id) => api.delete(`/knowledge/categories/${id}`);

// Knowledge Base Articles
export const getArticles = (categoryId) => 
  api.get('/knowledge/articles', { params: { category_id: categoryId } });
export const getArticle = (id) => api.get(`/knowledge/articles/${id}`);
export const createArticle = (data) => api.post('/knowledge/articles', data);
export const updateArticle = (id, data) => api.put(`/knowledge/articles/${id}`, data);
export const deleteArticle = (id) => api.delete(`/knowledge/articles/${id}`);

// Troubleshooting
export const getTroubleshootingFlows = () => api.get('/troubleshooting');
export const getTroubleshootingFlow = (id) => api.get(`/troubleshooting/${id}`);
export const createTroubleshootingFlow = (data) => api.post('/troubleshooting', data);
export const updateTroubleshootingFlow = (id, data) => api.put(`/troubleshooting/${id}`, data);
export const deleteTroubleshootingFlow = (id) => api.delete(`/troubleshooting/${id}`);

// Settings
export const getSettings = () => api.get('/settings');
export const updateSettings = (data) => api.put('/settings', data);

// Webhook
export const getWebhookLogs = (limit = 50, direction) => 
  api.get('/webhook/logs', { params: { limit, direction } });
export const testWebhook = (data) => api.post('/webhook/test', data);
export const sendMessage = (phoneNumber, message) => 
  api.post('/webhook/send', { phone_number: phoneNumber, message });

// License
export const checkLicense = (licenseKey) => 
  api.post('/license/check', { license_key: licenseKey });

// Seed data
export const seedData = () => api.post('/seed');

export default api;
